import ArrangementPublicationForm from './ArrangementPublicationForm';

export default ArrangementPublicationForm;
